const prefix = 'DimContact';

export enum DimContactField {
  ID = `${prefix}.id`,
  SUPPLIER_ID = `${prefix}.supplierId`,
  TITLE = `${prefix}.title`,
  FIRST_NAME = `${prefix}.firstName`,
  LAST_NAME = `${prefix}.lastName`,
  EMAIL = `${prefix}.email`,
  ROLE = `${prefix}.role`,
  PREFERRED_LANGUAGE = `${prefix}.preferredLanguage`,
  CREATED_AT = `${prefix}.createdAt`,
  UPDATED_AT = `${prefix}.updatedAt`,
}
